<template>
    <div class="tab-pane" :class="{ 'active': isActive }" v-show="isActive">
      <slot></slot>
    </div>
</template>

<script>
import { defineComponent, inject, ref, onMounted } from 'vue';

export default defineComponent({
    name: 'Tab',
    props: {
        title: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const isActive = ref(false);
        const tabs = inject('tabs');

        onMounted(() => {
            tabs.addTab({ title: props.title, isActive, selected: props.selected });
            if (props.selected) {
                isActive.value = true;
            }
        });

        return { isActive };
    },
});
</script>
  